// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile__edit-form--contact-info .profile-edit-dialog__section {
  gap: 0;
}

.profile__edit-form--contact-info .profile-edit-dialog__section + .profile-edit-dialog__section {
  border-top: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);
  padding-top: var(--spacing-xs, 0.75rem);
}

.profile__edit-form--contact-info .profile__section-header {
  margin-bottom: 0;
}

.profile__edit-form--contact-info .profile-edit-dialog__section fieldset {
  margin-top: 0.25rem;
  gap: var(--spacing-xs, 0.75rem);
}

.profile__edit-form--contact-info .profile-edit-dialog__section-heading {
  margin: 0;
  color: var(--gray-700, #364153);
  font-size: var(--font-size-md, 1rem); /* 16px */
  font-weight: var(--font-weight-md, 500);
  line-height: normal;
}

.profile-edit-dialog__phone-prefix-field {
  flex: 0 0 6.1rem;
  margin: 0;
}

.phonePrefixSelect,
.profile-edit-dialog__phone-local-input {
  border: 0 !important;
  background: transparent;
  min-height: calc(var(--min-touch-target, 44px) - 2px);
  height: calc(var(--min-touch-target, 44px) - 2px);
}

.phonePrefixSelect {
  padding: 0 0.2rem 0 0;
}

.phonePrefixSelect:focus,
.profile-edit-dialog__phone-local-input:focus {
  outline: none;
}

.profile-edit-dialog__phone-type-row {
  flex: 0 0 7.5rem;
}

.profile-edit-dialog__row--contact-point {
  max-width: 100%;
  width: 100%;
  border: 0;
  outline: 0;
  box-shadow: none;
}

.profile-edit-dialog__section fieldset > .profile-edit-dialog__row--contact-point {
  margin-bottom: var(--spacing-xs, 0.75rem);
}

.profile-edit-dialog__section fieldset > .profile-edit-dialog__row--contact-point:last-child {
  margin-bottom: var(--spacing-sm, 0.9375rem);
}

.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field,
.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type,
.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {
  border: 0;
  outline: 0;
  box-shadow: none;
  background: transparent;
}

.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {
  flex: 1 1 auto;
  min-width: 0;
}

.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {
  display: block;
  width: 100%;
}

.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.profile-edit-dialog__phone-type-row {
  flex: 0 0 6.5rem;
  width: 6.5rem;
  min-width: 6.5rem;
}

.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.emailTypeRow {
  flex: 0 0 6.5rem;
  width: 6.5rem;
  min-width: 6.5rem;
}

.profile-edit-dialog__row--address-header.profile-edit-dialog__row--full {
  max-width: 100%;
  width: 100%;
  align-items: center;
}

.profile-edit-dialog__row--address-header.profile-edit-dialog__row--full .profile-edit-dialog__actions {
  align-self: center;
}

.profile-edit-dialog__row--address-header.profile-edit-dialog__row--full .profile-edit-dialog__delete-button,
#profile-modal .modal .profile-edit-dialog__row--address-header.profile-edit-dialog__row--full button.profile-edit-dialog__delete-button {
  min-height: 1.75rem;
  min-width: 1.75rem;
}

.profile-edit-dialog__address-title {
  margin: 0;
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  line-height: var(--line-height-base, 1.5);
}

@media (max-width: 640px) {
  .profile-edit-dialog__row--contact-point {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-2xs, 0.625rem);
  }

  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {
    flex: 1 1 0;
    min-width: 0;
  }

  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.profile-edit-dialog__phone-type-row,
  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.emailTypeRow {
    flex: 0 0 5.5rem;
    width: 5.5rem;
    min-width: 5.5rem;
    max-width: 5.5rem;
  }

  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__actions {
    flex: 0 0 auto;
    margin-left: 0;
    justify-content: flex-end;
  }

  .profile-edit-dialog__phone-prefix-field {
    flex: 0 0 5.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/ContactInfoEditDialog.css"],"names":[],"mappings":"AAAA;EACE,MAAM;AACR;;AAEA;EACE,0EAA0E;EAC1E,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,oCAAoC,EAAE,SAAS;EAC/C,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;;EAGE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".profile__edit-form--contact-info .profile-edit-dialog__section {\n  gap: 0;\n}\n\n.profile__edit-form--contact-info .profile-edit-dialog__section + .profile-edit-dialog__section {\n  border-top: var(--border-width-sm, 0.1rem) solid var(--slate-200, #E2E8F0);\n  padding-top: var(--spacing-xs, 0.75rem);\n}\n\n.profile__edit-form--contact-info .profile__section-header {\n  margin-bottom: 0;\n}\n\n.profile__edit-form--contact-info .profile-edit-dialog__section fieldset {\n  margin-top: 0.25rem;\n  gap: var(--spacing-xs, 0.75rem);\n}\n\n.profile__edit-form--contact-info .profile-edit-dialog__section-heading {\n  margin: 0;\n  color: var(--gray-700, #364153);\n  font-size: var(--font-size-md, 1rem); /* 16px */\n  font-weight: var(--font-weight-md, 500);\n  line-height: normal;\n}\n\n.profile-edit-dialog__phone-prefix-field {\n  flex: 0 0 6.1rem;\n  margin: 0;\n}\n\n.phonePrefixSelect,\n.profile-edit-dialog__phone-local-input {\n  border: 0 !important;\n  background: transparent;\n  min-height: calc(var(--min-touch-target, 44px) - 2px);\n  height: calc(var(--min-touch-target, 44px) - 2px);\n}\n\n.phonePrefixSelect {\n  padding: 0 0.2rem 0 0;\n}\n\n.phonePrefixSelect:focus,\n.profile-edit-dialog__phone-local-input:focus {\n  outline: none;\n}\n\n.profile-edit-dialog__phone-type-row {\n  flex: 0 0 7.5rem;\n}\n\n.profile-edit-dialog__row--contact-point {\n  max-width: 100%;\n  width: 100%;\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n}\n\n.profile-edit-dialog__section fieldset > .profile-edit-dialog__row--contact-point {\n  margin-bottom: var(--spacing-xs, 0.75rem);\n}\n\n.profile-edit-dialog__section fieldset > .profile-edit-dialog__row--contact-point:last-child {\n  margin-bottom: var(--spacing-sm, 0.9375rem);\n}\n\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field,\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type,\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {\n  display: block;\n  width: 100%;\n}\n\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.profile-edit-dialog__phone-type-row {\n  flex: 0 0 6.5rem;\n  width: 6.5rem;\n  min-width: 6.5rem;\n}\n\n.profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.emailTypeRow {\n  flex: 0 0 6.5rem;\n  width: 6.5rem;\n  min-width: 6.5rem;\n}\n\n.profile-edit-dialog__row--address-header.profile-edit-dialog__row--full {\n  max-width: 100%;\n  width: 100%;\n  align-items: center;\n}\n\n.profile-edit-dialog__row--address-header.profile-edit-dialog__row--full .profile-edit-dialog__actions {\n  align-self: center;\n}\n\n.profile-edit-dialog__row--address-header.profile-edit-dialog__row--full .profile-edit-dialog__delete-button,\n#profile-modal .modal .profile-edit-dialog__row--address-header.profile-edit-dialog__row--full button.profile-edit-dialog__delete-button {\n  min-height: 1.75rem;\n  min-width: 1.75rem;\n}\n\n.profile-edit-dialog__address-title {\n  margin: 0;\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-medium, 500);\n  line-height: var(--line-height-base, 1.5);\n}\n\n@media (max-width: 640px) {\n  .profile-edit-dialog__row--contact-point {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-2xs, 0.625rem);\n  }\n\n  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.profile-edit-dialog__phone-type-row,\n  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field-type.emailTypeRow {\n    flex: 0 0 5.5rem;\n    width: 5.5rem;\n    min-width: 5.5rem;\n    max-width: 5.5rem;\n  }\n\n  .profile-edit-dialog__row--contact-point > .profile-edit-dialog__actions {\n    flex: 0 0 auto;\n    margin-left: 0;\n    justify-content: flex-end;\n  }\n\n  .profile-edit-dialog__phone-prefix-field {\n    flex: 0 0 5.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
